<ng-container *ngIf="this.selectedTab === 0">
  <div class="row">
    <div class="col col-1">
    </div>
    <div class="col-2 bold">
      Huidige periode
    </div>
    <div class="col-3 bold">
      Vorige periode
    </div>
  </div>
  <div class="pt-3"></div>
  <ng-container *ngIf="this.showCustomControls">
    <form [formGroup]="costsRawMaterialsConsumablesFg">
      <div class="row">
        <div class="col col-1">
          <p style="padding: 6px">Kosten van grond- en hulpstoffen</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(0)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
  </ng-container>
</ng-container>

<div *ngIf="this.index === 0">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.costsRawMaterialsConsumablesFg"
                                                       [title]="'kosten van grond- en hulpstoffen'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
